import React, { useEffect, useState } from 'react';
import TintucPageApi from './TintucPageApi';
import CategoryApi from './CategoryApi';

const AdminCategoryPage = ({ postType, pageTitle, clickChangeMenu, changeCurrentPostId }) => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [saveMessage, setSaveMessage] = useState('');

    const fetchCategories = () => {
        if (!postType) return;
        setIsLoading(true);
        TintucPageApi.getAllType(postType)
            .then(data => {
                setCategories(Array.isArray(data) ? data : []);
            })
            .catch(err => console.error(err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        fetchCategories();
    }, [postType]);

    const handleEditCategory = (catId) => {
        changeCurrentPostId(catId);
        clickChangeMenu('edit');
    };

    const handleClickDelete = (id) => {
        setDeleteId(id);
        setShowConfirm(true);
    };

    const handleConfirmDelete = async () => {
        setIsLoading(true);
        try {
            await CategoryApi.deleteCategory(deleteId);
            setSaveMessage('Xóa thành công!');
            setTimeout(() => setSaveMessage(''), 3000);
            fetchCategories();
        } catch (err) {
            setSaveMessage('Xóa thất bại!');
        } finally {
            setIsLoading(false);
            setShowConfirm(false);
            setDeleteId(null);
        }
    };

    return (
        <div>
            <div className="social-box">
                <h3 className="page-title">Chuyên mục {pageTitle}</h3>
                <div className="header">
                    <div className="btn-group">
                        <a
                            className="btn btn-primary"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                changeCurrentPostId(null);
                                clickChangeMenu('create');
                            }}>
                            <i className="icon-pencil" /> Tạo Chuyên mục {pageTitle}
                        </a>
                        <a
                            className="btn"
                            style={{ marginLeft: '5px' }}
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                clickChangeMenu('categoryList');
                            }}>
                            Quay lại
                        </a>
                    </div>
                    {saveMessage && (
                        <span style={{ marginLeft: '20px', color: saveMessage.includes('công') ? 'green' : 'red', fontWeight: 'bold' }}>
                            {saveMessage}
                        </span>
                    )}
                </div>
            </div>

            <div className="table-container">
                <table cellPadding={0} cellSpacing={0} border={0} className="table table-hover">
                    <thead>
                        <tr>
                            <th>Tiêu đề</th>
                            <th width="120px">Thứ tự</th>
                            <th width="160px" />
                            <th width="80px">Kích hoạt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="4" className="text-center">Đang tải...</td></tr>
                        ) : categories.length === 0 ? (
                            <tr><td colSpan="4" className="text-center">Chưa có dữ liệu</td></tr>
                        ) : (
                            categories.map((cat, index) => (
                                <tr key={cat.Id || index}>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        {cat.Owner_Id && <span style={{ color: '#999', paddingRight: '8px' }}>└</span>}
                                        {cat.Name}
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                        {cat.Order}
                                    </td>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        <button
                                            className="btn btn-success btn-small"
                                            style={{ marginRight: '5px' }}
                                            onClick={() => handleEditCategory(cat.Id)}>
                                            <i className="coloredicon page-white-edit" /> <strong>Sửa</strong>
                                        </button>
                                        <button
                                            className="btn btn-danger btn-small"
                                            onClick={() => handleClickDelete(cat.Id)}>
                                            <i className="coloredicon delete" /> <strong>Xóa</strong>
                                        </button>
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                        <input type="checkbox" checked={cat.Active === true || cat.Active === 'true'} readOnly />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Delete Confirm Modal */}
            {showConfirm && (
                <div className="modal-overlay1">
                    <div className="modal1">
                        <p>Bạn có chắc chắn muốn xóa chuyên mục này không?</p>
                        <div className="modal-actions1">
                            <button
                                onClick={handleConfirmDelete}
                                disabled={isLoading}
                                className="btn btn-danger">
                                {isLoading ? 'Đang xóa...' : 'Xóa'}
                            </button>
                            <button
                                onClick={() => { setShowConfirm(false); setDeleteId(null); }}
                                className="btn btn-secondary">
                                Hủy
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminCategoryPage;
